import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

import type { CurrentCommunity } from "../types/CurrentCommunity";

export interface BrandedAppsFeatureFlagsProps {
  brandedApp: {
    isEnabled: boolean;
  };
  brandedAppsBuilder: {
    isEnabled: boolean;
    isDesignConfigEnabled: boolean;
    isExtendedNavigationTabsEnabled: boolean;
    isMobileNavigationEnabled: boolean;
    isOrphanLinkConfigEnabled: boolean;
    isPreviewInsideBuilderEnabled: boolean;
    isWelcomePagesHomeTabsEnabled: boolean;
  };
}

export const checkIsBrandedAppsBuilderUIEnabled = (
  currentCommunity?: CurrentCommunity,
) => Boolean(currentCommunity?.custom_app_builder_feature_flag_enabled);

export const useBrandedAppsFeatureFlags = (): BrandedAppsFeatureFlagsProps => {
  const { currentCommunitySettings, currentCommunity } = usePunditUserContext();

  const isBrandedAppsBuilderUIEnabled =
    checkIsBrandedAppsBuilderUIEnabled(currentCommunity);

  const isBrandedAppEnabled = Boolean(
    currentCommunity?.branded_app_feature_flag_enabled,
  );

  const isDesignConfigEnabled = Boolean(
    currentCommunitySettings?.plus_design_config_enabled,
  );

  const isOrphanLinkConfigEnabled = Boolean(
    currentCommunitySettings?.plus_orphan_link_config_enabled,
  );

  const isWelcomePagesHomeTabsEnabled = Boolean(
    currentCommunitySettings?.welcome_page_home_tabs_enabled,
  );

  const isPreviewInsideBuilderEnabled = Boolean(
    currentCommunitySettings?.branded_mobile_app_builder_preview_enabled,
  );

  const isMobileNavigationEnabled = Boolean(
    currentCommunitySettings?.branded_apps_builder_mobile_navigation_enabled,
  );

  const isExtendedNavigationTabsEnabled = Boolean(
    currentCommunitySettings?.branded_apps_builder_extended_navigation_tabs_enabled,
  );

  return {
    brandedAppsBuilder: {
      isEnabled: isBrandedAppsBuilderUIEnabled,
      isDesignConfigEnabled,
      isExtendedNavigationTabsEnabled,
      isMobileNavigationEnabled,
      isOrphanLinkConfigEnabled,
      isWelcomePagesHomeTabsEnabled,
      isPreviewInsideBuilderEnabled,
    },
    brandedApp: {
      isEnabled: isBrandedAppEnabled,
    },
  };
};
